// extracted by mini-css-extract-plugin
export default {"imageContainer":"eba-z","summaryPar":"fba-z","ratingCategories":"gba-z","reviewerInfo":"hba-z","reviewTypes":"iba-z","expanded":"jba-z"};